import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { CheckIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core/react/i18n';

type ActionButtonProps = Readonly<{
	isFirstActive: boolean;
	primaryActionText: string;
	className?: string;
	dataQaSuffix?: string;
}>;

const PRIMARY_BUTTON_CLASSES =
	'text-typography-strong-fixed bg-gradient-to-r from-yellow-400 to-yellow-300 whitespace-nowrap';
const SECONDARY_BUTTON_CLASSES = 'whitespace-nowrap';

/**
 * Renders either a primary action button or a secondary "Done" button based on task state.
 */
export const ActionButton: React.FC<ActionButtonProps> = ({
	isFirstActive,
	primaryActionText,
	className = '',
	dataQaSuffix = '',
}) => {
	const variant = isFirstActive ? 'primary' : 'secondary';
	const dataQa = isFirstActive ? `dynamic-task-primary-cta${dataQaSuffix}` : `dynamic-task-done-button${dataQaSuffix}`;
	const buttonClasses = isFirstActive ? PRIMARY_BUTTON_CLASSES : SECONDARY_BUTTON_CLASSES;

	return (
		<Button
			variant={variant}
			size="x-small"
			data-qa={dataQa}
			className={cn(buttonClasses, className)}
			leadingIcon={isFirstActive ? undefined : <CheckIcon />}
		>
			{isFirstActive ? (
				primaryActionText
			) : (
				<Translate value="corgi.petition.starter_dashboard_v2.dynamic_tasks.task.done_button" />
			)}
		</Button>
	);
};
